import { render, staticRenderFns } from "./BtsList.vue?vue&type=template&id=327601cc&"
import script from "./BtsList.vue?vue&type=script&lang=js&"
export * from "./BtsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports